<input type="text" id="scriptHelper" class="sr-only">
<div class="main-content" *ngIf="!users">
    <div class="loader"></div>
</div>
<div class="main-content" *ngIf="users">
    <div class="container-fluid">
        <div class="col-lg-12 col-md-12">
            <div class="card">
                <div class="card-header">
                    <h4 class="card-title">Apoiadores</h4>
                    <small>A lista de seus clientes/usuários que apoiam uma causa social através da sua empresa.</small>
                    <!-- <div class="row">                         
                    <a class="btn btn-sm btn-success btn-wd"
                      href="http://storeapi.opolen.com.br/api/Excel/ExcelGetNgos?active=true" style="float:right">
                      <span class="ti-download"></span> Download Excel</a>      
                  </div> -->
                    <div class="card-content table-full-width" *ngIf="profile.storeSeoName != 'fabricacamisaria'">
                        <table class="table table-striped">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Cadastro em</th>
                                    <th>Nome</th>
                                    <th *ngIf="isHeroOrTravel">Documento</th>
                                    <th>Email</th>
                                    <th *ngIf="profile.storeSeoName == '99causas'">Cidade</th>
                                    <th>Causas</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let user of users; let i = index" [attr.data-index]="i">
                                    <td>
                                        {{i+1}}
                                    </td>
                                    <td>
                                        {{ user.createAt | date:'dd/MM/yyyy'}}
                                    </td>
                                    <td>
                                        {{ user.name}}
                                    </td>
                                    <td *ngIf="isHeroOrTravel">
                                        {{ user.document }}
                                    </td>
                                    <td>
                                        {{ user.email}}
                                    </td>
                                    <td *ngIf="profile.storeSeoName == '99causas'">
                                        {{ user.city}}
                                    </td>
                                    <td *ngIf="user.listNgos != null && user.listNgos.length > 0">
                                        {{ user.listNgos[0]}}
                                    </td>
                                    <td *ngIf="user.listNgos == null || user.listNgos.length == 0">
                                        -
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="card-content table-full-width" *ngIf="profile.storeSeoName == 'fabricacamisaria'">
                        <table class="table table-striped">
                            <thead>
                                <tr>
                                    <th>C</th>
                                    <th>#</th>
                                    <th>Cadastro em</th>
                                    <th>Nome</th>
                                    <th>Documento</th>
                                    <th>Email</th>
                                    <th>Causas</th>
                                    <th>Vendido</th>
                                    <th>Doado</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let user of users; let i = index" [attr.data-index]="i">
                                    <td>
                                        <i class="fas fa-check" style="font-size: 17px;color:green"
                                            title="cnpj encontrado na tinyErp" *ngIf="user.verified"></i>
                                        <i class="fa fa-remove" style="font-size: 17px;color:grey"
                                            title="cnpj não encontrado na tinyErp" *ngIf="!user.verified"></i>
                                    </td>
                                    <td>
                                        {{i+1}}
                                    </td>
                                    <td>
                                        {{ user.createAt | date:'dd/MM/yyyy'}}
                                    </td>
                                    <td>
                                        {{ user.name}}
                                    </td>
                                    <td>
                                        {{ user.document}}
                                    </td>
                                    <td>
                                        {{ user.email}}
                                    </td>
                                    <td>
                                        {{ user.listNgos[0]}}
                                    </td>
                                    <td>
                                        R${{ user.totalPurchases | number:'.2-2'}}
                                    </td>
                                    <td>
                                        R${{ user.totalDonated | number:'.2-2'}}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>